var map = {
	"./icons/MinusIcon": "88ae",
	"./icons/MinusIcon.vue": "88ae",
	"./icons/PlusIcon": "ee8a",
	"./icons/PlusIcon.vue": "ee8a",
	"./logo.png": "cf05",
	"./mastercard.png": "7e5a",
	"./product-1.jpeg": "745f",
	"./product-2.jpeg": "3e50"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";